import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sidemenu from '../SideMenu/SideMenu';
import AdminDashboard from './Admin';
import { getUserRoleType } from '../../services/aws/aws-services';
import { actions, errorMessages } from '../../helpers/messages'
import UnauthorizedUser from './UnauthorizedUser';
import { RoleNameKeyMap, RolePermission } from '../../helpers/constants';
import ActiveDirectoryUser from './ActiveDirectoryUser';
import FallbackDashboard from './FallbackDashboard';
import { isFederatedLogin } from '../../helpers/GlobalFunctions';

class DashboardComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: props.loading === true,
			showBanner: true
		}
	}

	/**
	* @description Function to toggle loader
	* @param status Show/hide status of the loader
	* @memberof DashboardComponent
	*/
	/* istanbul ignore next  */
	toggleLoading = (status) => {
		this.setState({ loading: status })
	}

	/**
	* @description Function to switch between role based dashboards
	* @param 
	* @memberof DashboardComponent
	*/
	getDashboard = () => {
		const loggedInUserType = getUserRoleType();
		const isADUser = isFederatedLogin();
		if (RolePermission.login.indexOf(loggedInUserType) === -1) {
			return <UnauthorizedUser errroMsg={isADUser ? errorMessages.accessDeniedForADUsers : errorMessages[403]} />
		}
		if (loggedInUserType === RoleNameKeyMap.admin) {
			return <AdminDashboard />
		} else if (isADUser) {
			return <ActiveDirectoryUser />
		} else {
			return <FallbackDashboard />
		}
	}

	render() {
		const { loggerObj, role, federatedLogin } = this.props;
		
		return (<>
			{this.state.loading ? <div className="loading-overlay"><span>{actions.load}</span></div> : null}
			{federatedLogin && !role ? '' :
				<div className="bgGray">
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-1">
								<Sidemenu loggerObj={loggerObj} />
							</div>
							<div className="col-md-11" >
								{this.getDashboard()}
							</div>
						</div>
					</div>
				</div>
				}
		</>);
	}
}
const mapStateToProps = (state) => (
	{
		state
	}
)
const mapDispatchToProps = (dispatch) => ({

})
export default connect(mapStateToProps, mapDispatchToProps)(DashboardComponent);
